import { faCheck, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';

function UserProfileForm(props) {
    const [name, setName] = useState(() => localStorage.getItem("nome") || "");
    const [email, setEmail] = useState(localStorage.getItem("email") || "");
    const [alterarSenha, setAlterarSenha] = useState(false);
    const [password, setPassword] = useState(localStorage.getItem("password") || "");
    const [confirmPassword, setConfirmPassword] = useState(localStorage.getItem("confirmPassword") || "");

    const nameValidationPattern = /^[A-Za-zÀ-ÿ]+( [A-Za-zÀ-ÿ]+)+$/;
    const emailValidationPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    const passwordValidationPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;

    const [validated, setValidated] = useState(false);


    useEffect(() => {
        localStorage.setItem("nome", name);
    }, [name]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            console.log("opa");
            event.preventDefault();
            event.stopPropagation();
        }
        console.log("aipo");

        // setValidated(true);
        // return;
        const userProfile = {
            name,
            email,
            password,
            confirmPassword
        };
        console.log(userProfile);

        if (alterarSenha) {
            if (password === confirmPassword) {
                userProfile['password'] = password;
                userProfile['confirmPassword'] = confirmPassword;
            } else {// senhas nao coincidem
                alert("As senhas não coincidem.");
            }
        }

        props.submitHandler(userProfile);
    };

    const passwordVerify = () => {
        return password === confirmPassword
    };

    return (
        <Container className="mt-5">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                {/* Informações Básicas */}
                <h5>Informações Básicas</h5>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formName">
                            <Form.Label>Nome completo:</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Digite seu nome"
                                value={name}
                                pattern={nameValidationPattern}
                                required
                                isInvalid={!nameValidationPattern.test(name)}
                                isValid={nameValidationPattern.test(name)}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> Forneça um nome inválido.</small></Form.Control.Feedback>
                            <Form.Control.Feedback><small><FontAwesomeIcon icon={faCheck} /> Nome válido.</small></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formEmail">
                            <Form.Label>Email:</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Digite seu email"
                                value={email}
                                required
                                isInvalid={!emailValidationPattern.test(email)}
                                isValid={emailValidationPattern.test(email)}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> Forneça um endereço válido.</small></Form.Control.Feedback>
                            <Form.Control.Feedback><small><FontAwesomeIcon icon={faCheck} /> Endereço válido.</small></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className='mb-3'>
                    {props.editPassword &&
                        <Col md={2}>
                            <Form.Group controlId="formAlterarSenha" className="mt-2">
                                <Form.Check
                                    type="checkbox"
                                    label="Alterar senha"
                                    checked={alterarSenha}
                                    onChange={(e) => setAlterarSenha(e.target.checked)}
                                />
                            </Form.Group>
                        </Col>
                    }
                    <Col md={props.editPassword ? 5 : 6}>
                        <Form.Group controlId="formPassword">
                            <Form.Label>Senha:</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Digite sua senha"
                                value={password}
                                required
                                isInvalid={!passwordValidationPattern.test(password)}
                                isValid={passwordValidationPattern.test(password)}
                                disabled={!alterarSenha && props.editPassword}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            {(alterarSenha || !props.edit) && <>
                                <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> A senha deve conter ao menos 8 caracteres entre eles 1 letra minúscula, 1 letra maiúscula e 1 número.</small></Form.Control.Feedback>
                                <Form.Control.Feedback type="valid"><small><FontAwesomeIcon icon={faCheck} /> Senha válida.</small></Form.Control.Feedback>
                            </>}
                            {(props.edit && !alterarSenha) && <>
                                <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> A senha não será alterada.</small></Form.Control.Feedback>
                            </>}
                        </Form.Group>
                    </Col>
                    <Col md={props.editPassword ? 5 : 6}>
                        <Form.Group controlId="formConfirmPassword">
                            <Form.Label>Confirme sua Senha:</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Confirme sua senha"
                                value={confirmPassword}
                                required
                                isInvalid={!passwordValidationPattern.test(confirmPassword) || !passwordVerify()}
                                isValid={passwordValidationPattern.test(confirmPassword) && passwordVerify()}
                                disabled={!alterarSenha && props.editPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            {(alterarSenha || !props.edit) && <>
                                {passwordValidationPattern.test(confirmPassword) && !passwordVerify() ? (
                                    <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> As senhas devem coincidir.</small></Form.Control.Feedback>
                                ) : (
                                    <Form.Control.Feedback type="invalid"><small><FontAwesomeIcon icon={faTimes} /> A senha deve conter ao menos 8 caracteres entre eles 1 letra minúscula, 1 letra maiúscula e 1 número.</small></Form.Control.Feedback>
                                )}
                                <Form.Control.Feedback type="valid"><small><FontAwesomeIcon icon={faCheck} /> Confirmação de senha válida.</small></Form.Control.Feedback>
                            </>}
                        </Form.Group>
                    </Col>
                </Row>
                <Button variant="primary" type="submit"><FontAwesomeIcon icon={faSave} />&nbsp;Salvar</Button>
            </Form>
        </Container>
    );
}

export default UserProfileForm;
